import { Grid, Typography } from "@mui/material";
import { FormikProps } from "formik";

import { FormikAutocompleteSelect } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocompleteSelect";
import {
  ordinalOptions,
  weekdayOptions,
} from "@/pages/system-settings/tabs/courts/vienna/components/CourtLabels.utils";
import { CourtFormType } from "@/pages/system-settings/tabs/courts/vienna/components/court-dialog/court-form-fields/CourtForm.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<CourtFormType>;
  index: number;
}

export function RuleDayFields({ formik, index }: Props) {
  const { t } = useTranslation();
  const base = `courtDays.${index}` as const;

  return (
    <>
      <Grid size={2.5}>
        <FormikAutocompleteSelect
          formik={formik}
          path={`${base}.ordinal`}
          label={t("settings.courts.gerichtstag.rule")}
          options={ordinalOptions(t)}
        />
      </Grid>
      <Grid size={3}>
        <FormikAutocompleteSelect
          formik={formik}
          path={`${base}.weekday`}
          label={t("settings.courts.gerichtstag.weekday")}
          options={weekdayOptions(t)}
        />
      </Grid>
      <Grid size={2.5} sx={{ display: "flex", alignItems: "flex-start", pt: 1 }}>
        <Typography>{t("settings.courts.gerichtstag.perMonth")}</Typography>
      </Grid>
    </>
  );
}
